import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role, roles, requireApproved }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center font-display text-2xl">Loading…</div>;
  }
  if (!user || user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const allowed = roles ? roles : (role ? [role] : null);
  if (allowed) {
    const isOwnerOnRecruiterRoute = allowed.includes("recruiter") && user.role === "owner";
    const isOwnerOnModRoute = allowed.includes("moderator") && user.role === "owner";
    if (!allowed.includes(user.role) && !isOwnerOnRecruiterRoute && !isOwnerOnModRoute) {
      return <Navigate to="/" replace />;
    }
  }
  // Gate pending recruiters out of recruiter-only flows (dashboard / pipeline / billing / job editor)
  if (requireApproved && user.role === "recruiter" && !user.is_approved) {
    return <Navigate to="/pending-approval" replace />;
  }
  return children;
}
